import $ from 'jquery'
import { storeLocally, retrieveLocally } from '../utilities'

// @see http://www.appsumo.com/7-tips-grow-your-emails/
const openDelay = 5 * 1000  // 5 seconds
const hideDuration = 2 * 7 * 24 * 60 * 60 * 1000  // 2 weeks

export default function()
{
	const $popup = $('#popup')
	const toggler = $popup.data('toggler')

	$popup.on('click', (e) => (e.target === $popup[0]) && toggler.close())
	toggler.on('change', ({ newValue }) => newValue && storeLocally('hidePopup', true, hideDuration))

	// WHAT. WHY.
	$popup.find('a').on('click', function()
	{
		document.location.href = this.href
	})

	if(!retrieveLocally('hidePopup'))
	{
		setTimeout(() => toggler.open(), openDelay)
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/popup.js